import _ from 'lodash';
import { UPDATE_USER_SUCCESS } from '../actions/update-user';

export default (state, action = {}) => {
  switch (action.type) {
    case UPDATE_USER_SUCCESS: {
      const user = action.payload;
      if (_.get(state, '_id.value') === action.payload._id) {
        return {
          ...state,
          name: {
            ...state.name,
            initial: user.name,
            value: user.name,
          },
          cover: {
            ...state.cover,
            initial: user.cover,
            value: user.cover,
          },
          image: {
            ...state.image,
            initial: user.image,
            value: user.image,
          },
        };
      }
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/profile-form.js